// @ts-nocheck


import React from 'react';


import { commonHeaderPanel } from '../lib';

import OperationBudgetTab from '../OperationBudget/components/Tabs';

export const headerPanel = (props) => {
  const { title, vehiclePlanId } = props;
  return (
    <>
      {commonHeaderPanel({ title, vehiclePlanId })}
      <OperationBudgetTab vehiclePlanId={props.vehiclePlanId} />
    </>);

};
